/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbBulletinApprenantRecapitulatifGridDto } from './FcbBulletinApprenantRecapitulatifGridDto';
import {
    FcbBulletinApprenantRecapitulatifGridDtoFromJSON,
    FcbBulletinApprenantRecapitulatifGridDtoFromJSONTyped,
    FcbBulletinApprenantRecapitulatifGridDtoToJSON,
} from './FcbBulletinApprenantRecapitulatifGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults
 */
export interface FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbBulletinApprenantRecapitulatifGridDto>}
     * @memberof FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults
     */
    results?: Array<FcbBulletinApprenantRecapitulatifGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults interface.
 */
export function instanceOfFcbBulletinApprenantRecapitulatifGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbBulletinApprenantRecapitulatifGridDtoPaginatedResultsFromJSON(json: any): FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults {
    return FcbBulletinApprenantRecapitulatifGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbBulletinApprenantRecapitulatifGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbBulletinApprenantRecapitulatifGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbBulletinApprenantRecapitulatifGridDtoPaginatedResultsToJSON(value?: FcbBulletinApprenantRecapitulatifGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbBulletinApprenantRecapitulatifGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

